"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
// noinspection JSUnusedGlobalSymbols
function useOptions() {
    return (0, react_redux_1.useSelector)(function (state) { return state.options; });
}
exports.default = useOptions;
